import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import BelongingsPrintRow from '../BelongingsPrintRow/BelongingsPrintRow';
import styles from './BelongingsPrintTable.module.scss';

interface BelongingsGroup {
    locationName: string;
    items: Array<any>;
}

interface BelongingsPrintTableProps {
    groups: BelongingsGroup[];
}

const ColumnHeaders: React.FC = () => (
    <tr className={styles.colHeaderRow}>
        <th className={styles.colPet}>Pet &amp; Belongings</th>
        <th className={styles.colRoom}>Room</th>
        <th className={styles.colNotes}>Notes</th>
    </tr>
);

export const BelongingsPrintTable: React.FC<BelongingsPrintTableProps> = ({ groups }) => {
    return (
        <table className={styles.table}>
            <tbody>
                {groups.map(group => (
                    <React.Fragment key={group.locationName}>
                        <tr className={styles.locationRow}>
                            <td
                                className={styles.locationCell}
                                colSpan={3}
                            >
                                <FontAwesomeIcon
                                    icon={faLocationDot}
                                    className={styles.locationIcon}
                                />
                                <span className={styles.locationText}>{group.locationName}</span>
                            </td>
                        </tr>
                        <ColumnHeaders />
                        {group.items.map(item => (
                            <BelongingsPrintRow
                                key={item.id}
                                item={item}
                            />
                        ))}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    );
};

export default BelongingsPrintTable;
